import React from "react";
import ItemCard from "../ItemCard";
import { getRiotAssetsContext } from "@outplayed/riot-assets";

const ItemBuildsInto = (props) => {
  const { useItemsWiki } = getRiotAssetsContext();
  const itemsList = useItemsWiki({ ssr: true });
  const itemsJSON = itemsList.data;
  const availableItems = itemsJSON?.availableItems;
  const { itemData, itemId } = props;
  if (!itemData || !itemId) return null;

  const itemCardProps = {
    showGold: false,
    itemClass: "items-pic-30 items-border-normal-small",
    textClass: "text-small",
  };

  const itemsBuildsInto = itemData.into.filter((id) => availableItems.includes(parseInt(id)));

  return (
    <div className="items-section items-builds-into">
      <div className="items-header">Builds Into</div>
      <div className="builds-into-container">
        {itemsBuildsInto?.map((id) => (
          <ItemCard {...itemCardProps} itemId={id} key={id} />
        ))}
      </div>
    </div>
  );
};

export default ItemBuildsInto;
